import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";

export interface IProgressProps {
  stages: {
    isLoaded: boolean;
    text: string;
  }[];
}

const SIZE = "1.25em !important";

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  textContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 2,
  },
  text: { paddingLeft: 1, fontWeight: "bold" },
  icon: { width: SIZE, height: SIZE },
};

export const Progress = (props: IProgressProps) => {
  const { stages } = props;

  return (
    <Box sx={styles.container}>
      <Paper sx={{ p: 4 }}>
        {stages.map(({ isLoaded, text }) => (
          <Box key={text} sx={styles.textContainer}>
            {isLoaded ? (
              <CheckCircleRoundedIcon sx={styles.icon} color="primary" />
            ) : (
              <RadioButtonUncheckedRoundedIcon sx={styles.icon} />
            )}
            <Typography sx={styles.text}>{text}</Typography>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};
